import SectionHero from "modules/ui/components/SectionHero/SectionHero";
import React, { useEffect } from "react";
import BgGlassmorphism from "modules/ui/components/BgGlassmorphism/BgGlassmorphism";
import PublicLayout from "../../modules/ui/components/PublicLayout";
import { useParams } from "react-router-dom";
import CityEventDescription from "./CityEventDescription";
import useEventCityGet from "../../modules/eventCities/hooks/useEventCityGet";
import HotelsMapGridSection from "./MainEventCitySection/HotelsMapGridSection";
import useBookingSearchContext from "../../modules/booking/hooks/useBookingSearchContext";
import Loader from "modules/ui/shared/Loader/Loader";
import moment from "moment";
import SectionSearchForm from "./SectionSearchForm";

function PageCityEvent() {
    const { id } = useParams();

    const {
        city: bookSearchCity,
        setCity: setBookSearchCity,
        dates: bookDates,
        setDates: setBookDates,
        cities: bookCities
    } = useBookingSearchContext();

    const { data: eventCity } = useEventCityGet(id);

    const bookFrom = bookSearchCity?.id === eventCity?.id ? bookDates.startDate?.format("DD/MM/YYYY") || null : eventCity?.startDate;
    const bookUntil = bookSearchCity?.id === eventCity?.id ? bookDates.endDate?.format("DD/MM/YYYY") || null : eventCity?.endDate;

    useEffect(() => {
        if (bookCities && eventCity && bookSearchCity?.id !== eventCity.id) {
            const newBookCity = bookCities.find((bookCity) => bookCity.id === eventCity.id) || null;
            setBookSearchCity(newBookCity);
            setBookDates({
                startDate: newBookCity?.startDate ? moment(newBookCity.startDate) : null,
                endDate: newBookCity?.endDate ? moment(newBookCity?.endDate) : null,
            });
        }
    }, [eventCity, bookSearchCity, setBookSearchCity, setBookDates, bookCities]);

    return (
        <PublicLayout>
            <div className="nc-ListingStayMapPage relative">
                {/* GLASSMOPHIN */}
                <BgGlassmorphism/>

                {/* SECTION HERO */}
                {eventCity ?
                    <SectionHero mainImage={eventCity.bannerContentUrl}
                                 imageContainerClassName="lg:h-[350px] overflow-hidden"
                                 showBookForm={false} />
                    : <Loader centerHorizontally />}

                <SectionSearchForm />

                <div className="container relative space-y-10 my-10 lg:space-y-12 lg:my-12">
                    {/* EVENT DESCRIPTION */}
                    <CityEventDescription eventCity={eventCity}/>
                </div>
                {/* SECTION */}
                <div className="container pb-24 lg:pb-28 2xl:px-10 xl:pr-0 xl:max-w-none">
                    {eventCity ?
                        <HotelsMapGridSection eventCity={eventCity} bookFrom={bookFrom} bookUntil={bookUntil}/>
                        : <Loader centerHorizontally />}
                </div>

            </div>
        </PublicLayout>
    );
}

export default PageCityEvent;
